<template>
  <div class="cat-tiposrazones-sinoj ">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de razon</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los tipos de razones</option>        
        <option v-for="(tipoRazon,index) in tiposDeRazones" :value="tipoRazon.TipoRazonId" :key="index">{{tipoRazon.Nombre}}</option>
      </select>      
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        tiposDeRazones: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 022TiposRazones
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let tipoRazonObj = this.obtenerTipoRazonObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer015TiposRazones",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,tipoRazonObj);
      },
      obtenerTipoRazonObj: function(tipoRazonId) {
        let id = parseInt(tipoRazonId);
        let tipoRazon = null;
        this.tiposDeRazones.filter(trBD => trBD.TipoRazonId == id).forEach(tr => {tipoRazon = tr});
        return tipoRazon;
      },
      /**
       * Metodo para llenar catalogo 022TiposRazones mediante el llamado de la API
       */
      cargarTiposDeRazones: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API = api.SINOJ.catalogos.C022TiposDeRazones;
        let urlApi = SERVIDOR + METODO_API;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);

        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else { 
                        this.tiposDeRazones = respuesta.data.TiposRazones;
                    }
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer015TiposRazones", valoresDelCatalogo);
    },
    created() {
      this.cargarTiposDeRazones();
    }
  }
</script>
<style>
.cat-tiposrazones-sinoj .form-control {
  background-color: white !important;
        color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C022TiposDeRazones.vue